import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import { Map } from './map/Map';
import { useTripMapFeatures } from '../hooks/useTripMapFeatures';

type Props = {
  trip: TripOutput;
};

export const TripMap = ({ trip }: Props) => {
  const { markers, bounds, paths } = useTripMapFeatures(trip);

  return <Map markers={markers} bounds={bounds} lines={paths} />;
};
